__turbopack_context__.v({
  "collapsibleGroupHeader": "aqP8sq_collapsibleGroupHeader",
  "dense": "aqP8sq_dense",
  "multi": "aqP8sq_multi",
  "resizer": "aqP8sq_resizer",
  "scrollingVertically": "aqP8sq_scrollingVertically",
  "selected": "aqP8sq_selected",
  "sorted": "aqP8sq_sorted",
  "table": "aqP8sq_table",
});
